import React from "react";
import { Link } from "react-router-dom";
import { Flame, Home as HomeIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => (
  <section className="relative flex min-h-screen items-center justify-center overflow-hidden bg-navy px-5 pt-20 text-center">
    <div className="relative">
      <Flame className="mx-auto h-14 w-14 text-brand-orange" />
      <p className="mt-8 font-display text-7xl font-extrabold text-white md:text-8xl">404</p>
      <h1 className="mt-4 font-display text-2xl font-bold text-white md:text-3xl">This page could not be found</h1>
      <p className="mx-auto mt-3 max-w-md text-white/60">
        The page you’re looking for doesn’t exist or has moved. Let’s get you back on the path.
      </p>
      <Button asChild data-testid="notfound-home-btn" className="mt-8 rounded-sm bg-brand-orange px-8 py-6 font-display uppercase tracking-wide hover:bg-brand-orange-600">
        <Link to="/"><HomeIcon className="mr-2 h-4 w-4" /> Back to Home</Link>
      </Button>
    </div>
  </section>
);

export default NotFound;
